import React, { useEffect } from "react";
import {
  Routes,
  Route,
  Navigate,
  useNavigate,
  useLocation,
} from "react-router-dom";
import { adminRoutes } from "./routes/adminRoutes";
import NotFound from "./pages/NotFound";
import PrivateRoute from "./routes/privateRoutes";
import { setToken } from "./store/auth/login/action";
import { useDispatch } from "react-redux";
import AdminNavbar from "./components/partial/AdminNavbar";
const App = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation(); // Hook to get the current location (path)

  const storedUser = (() => {
    try {
      return JSON.parse(localStorage.getItem("user") || "null");
    } catch (e) {
      return null;
    }
  })();
  const date = Date.now();

  useEffect(() => {
    if (storedUser) {
      // treat presence of stored user as authenticated
      dispatch(setToken(storedUser));
    } else {
      dispatch(setToken(undefined));
    }
  }, [dispatch, date, navigate]);

  // Conditional rendering based on the current path
  const showSidebar = location.pathname !== "/nvm-admin"; // Hide sidebar on '/nvm-admin'

  return (
    <div className="flex flex-col h-screen">
      <div className="flex flex-1">
        {showSidebar && <AdminNavbar />}{" "}
        {/* Conditionally render AdminNavbar (sidebar) */}
        <div className={`flex-1`}>
          <Routes>
            <Route path="/" element={<Navigate to="/nvm-admin" />} />
            {/* Admin Routes */}
            {adminRoutes.map((admin, index) => (
              <Route
                path={admin.path}
                element={<PrivateRoute>{admin.element}</PrivateRoute>}
                key={index}
              />
            ))}

            {/* Catch-all route for undefined paths (404 page) */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
      </div>
    </div>
  );
};

export default App;

// All gud
